import Vue from 'vue';
import 'vant/lib/index.css';

import {
    Lazyload,
    Tab,
    Tabs,
    Loading,
    Popup,
    Picker,
    Button,
    Icon,
    Field,
    Overlay,
    Notify
} from 'vant';

Vue.use(Tab).use(Tabs);
Vue.use(Lazyload);
Vue.use(Loading);
Vue.use(Popup);
Vue.use(Picker);
Vue.use(Button);
Vue.use(Icon);
Vue.use(Field);
Vue.use(Overlay);
Vue.use(Notify);